"use client";

import { type CSSProperties, type ReactNode } from "react";
import { usePartnerStudentBranding } from "@/hooks/usePartnerStudentBranding";
import { PartnerBrandingProvider } from "./PartnerBrandingContext";
import PartnerCoBrandChrome from "./PartnerCoBrandChrome";

/**
 * Wraps B2B-capable routes (assessment, onboarding) to load co-branding when the user is partner-linked.
 * Renders children immediately so B2C never blocks on this fetch.
 */
export default function PartnerExperienceLayoutClient({ children }: { children: ReactNode }) {
  const branding = usePartnerStudentBranding(true);

  const show = branding?.active === true;

  const shellStyle: CSSProperties = {
    ["--partner-primary" as string]: show
      ? (branding?.primary_color ?? "#f59e0b")
      : "#f59e0b",
    ["--partner-secondary" as string]: show
      ? (branding?.secondary_color ?? "#6366f1")
      : "#6366f1",
  };

  return (
    <PartnerBrandingProvider branding={branding}>
      <div className="min-h-screen bg-slate-950" style={shellStyle}>
        {show && branding ? <PartnerCoBrandChrome branding={branding} /> : null}
        {children}
      </div>
    </PartnerBrandingProvider>
  );
}
